import { useQuery } from "@tanstack/react-query";

const zohoFn = async ({ Entity }) => {
  let systemMandatoryTrue = [];
  let systemMandatoryFalse = [];
  let dateAndDatetimeFields = [];

  const data = await window.ZOHO.CRM.META.getFields({ Entity });

  data?.fields?.forEach((field) => {
    const { id, api_name, data_type, field_label, custom_field, system_mandatory, display_label } = field;
    const obj = {
      id,
      api_name,
      data_type,
      field_label,
      custom_field,
      display_label,
      system_mandatory,
    };

    if (system_mandatory) {
      systemMandatoryTrue.push(obj);
    } else {
      systemMandatoryFalse.push(obj);
    }

    if ((data_type === "datetime" || data_type === "date") && custom_field === true) {
      dateAndDatetimeFields.push(obj);
    }
  });
  console.log(dateAndDatetimeFields);

  return { systemMandatoryTrue, systemMandatoryFalse, dateAndDatetimeFields };
};

export const useModuleFields = ({ moduleApiName }) => {
  const { isFetching, data, isError, error } = useQuery({
    queryKey: ["moduleFields", moduleApiName],
    staleTime: Infinity,
    enabled: Boolean(moduleApiName),
    queryFn: () => zohoFn({ Entity: moduleApiName }),
  });

  return { moduleFields: data, isFetching, isError };
};
